import { Alert, useTheme } from '@mui/material';
import { differenceInDays } from 'date-fns';
import { Link } from 'react-router-dom';
import { PATH_SETTINGS } from 'src/Router/paths';
import { useLocales } from 'src/locales';

type Props = {
  endAt?: string;
};
export function TrialEndingAlert({ endAt }: Props) {
  const theme = useTheme();
  const { translate } = useLocales();

  return (
    <Alert severity="warning">
      {translate('trial_ending_alert.trial_ending_in', {
        days: differenceInDays(new Date(endAt as string), new Date()),
      })}
      &nbsp;
      <Link
        to={PATH_SETTINGS.workspace.billing}
        style={{ color: theme.palette.text.primary }}
      >
        {translate('workspace_settings.billing.title')}
      </Link>
      &nbsp;
      {translate('trial_ending_alert.to_review')}
    </Alert>
  );
}
